import { render, staticRenderFns } from "./lookSingleExam.vue?vue&type=template&id=f3e996b0&scoped=true&"
import script from "./lookSingleExam.vue?vue&type=script&lang=js&"
export * from "./lookSingleExam.vue?vue&type=script&lang=js&"
import style0 from "./lookSingleExam.vue?vue&type=style&index=0&id=f3e996b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e996b0",
  null
  
)

export default component.exports